import { mapState } from 'vuex';
export default {
  name: 'CoreAccountSelector',
  inheritAttrs: false,
  props: {
    value: {
      type: [Object, Number],
      default: () => null,
      required: false
    }
  },
  data: function () {
    return {
      accounts: [],
      isLoading: false,
      commonAttrs: {},
      disabled: false
    };
  },
  computed: {
    ...mapState('app', ['color', 'inpOutlined', 'inpFilled']),
    isRequired() {
      return this.$attrs.required === '' || Boolean(this.$attrs.required);
    },
    isDisabled() {
      return this.isLoading || this.$attrs.disabled || this.disabled;
    }
  },
  mounted() {
    this.fetchAccounts();
  },
  methods: {
    /**
     * Fetch accounts from the API and store them in the accounts array.
     * @returns {void}
     */
    fetchAccounts() {
      this.isLoading = true;
      this.$store.dispatch('app/loadAccounts').then(accounts => {
        this.accounts = accounts;
        this.$emit('accounts-loaded');
      }).catch(error => {
        this.disabled = true;
        this.$snack(this.$i18n_t('Common.errorLoadingAccounts'), 'error');
        this.$emit('accounts-error');
        console.error(error);
      }).finally(() => {
        this.isLoading = false;
      });
    }
  }
};